export enum AppScope {
  /**
   * Includes NY and all future states until CA is migrated over. If there is state-specific
   * logic, then this can be broken down further.
   */
  Default = 'DEFAULT',
  // Until migration is complete, CA experience on the this frontend will be a separate app scope.
  CA = 'CA',
}
